.clipContainer {
  display: flex;
  position: relative;
  margin: 8px 0;
  border: 1px solid var(--tuna-palette-action-focus);
  border-radius: 8px;
}
